import { logAdapterEvent, logError } from "../../helper/logger";
import { pickChannels } from "../../helper/channels-service-helpers";
import { ICreditOffer } from "lib/types/global";

const ADAPTER_NAME = "CustomerAcqCompareTool";

export function dynamicCustomerAcqCompareAdapter({
  componentProps,
  channelListingData,
  channelsServiceData,
  rsnTierLegalText,
  genreLocalChannelMapping,
  signatureExcludedLocalChannels,
  embeddedSvods,
  embeddedIncludedSvods,
  getOffersGenreData,
  offerPrices,
  byodPlanCardOffers,
  genreNationals,
  packagesConfig,
  genrePackOfferIds,
  creditOffers,
  queryParams
}: {
  componentProps: any,
  channelListingData?: any,
  channelsServiceData?: any,
  rsnTierLegalText?: any,
  genreLocalChannelMapping?: any,
  signatureExcludedLocalChannels?: any[],
  embeddedSvods?: any,
  embeddedIncludedSvods?: any,
  getOffersGenreData?: any,
  offerPrices?: any,
  byodPlanCardOffers?: any,
  genreNationals?: any,
  packagesConfig?: any,
  genrePackOfferIds?: any,
  creditOffers?: ICreditOffer[],
  queryParams?: any
}) {
  try {
    logAdapterEvent(ADAPTER_NAME, "dynamicCustomerAcqCompareAdapter", {
      componentProps,
      queryParams
    });
    let queryParameters = [];
    let type = '';
    if (Array.isArray(queryParams)) {
      queryParameters = queryParams.map(p => String(p).replace(/['"]/g, "").trim()).filter(Boolean);
    } else {
      const pkgIdsParam = queryParams?.cmpPkg;
      if (Array.isArray(pkgIdsParam)) {
        queryParameters = pkgIdsParam.map(p => String(p).replace(/['"]/g, "").trim()).filter(Boolean);
      } else if (typeof pkgIdsParam === "string") {
        queryParameters = pkgIdsParam.split(",").map(p => p.replace(/['"]/g, "").trim()).filter(Boolean);
      }
      if (typeof queryParams?.type === 'string') {
        type = queryParams.type.replace(/['"]/g, '').trim().toLowerCase();
      }
    }

    // Generated by Copilot- Start - 2026-04-21 15:22:02
    const isByod = type === 'byod';
    const hasByodOffers = isByod && Array.isArray(byodPlanCardOffers?.offerPrices) && byodPlanCardOffers.offerPrices.length > 0;
    const activeOfferData = hasByodOffers ? byodPlanCardOffers : offerPrices;

    let resolvedOfferPrices = activeOfferData;
    if (Array.isArray(activeOfferData?.offerPrices)) {
      resolvedOfferPrices = {
        ...activeOfferData,
        offerPrices: activeOfferData.offerPrices.map(pkgOffer => {
          const pkgKey = Object.keys(pkgOffer).find(k => k !== 'byodPrice' && k !== 'benefits' && typeof pkgOffer[k] === "number");
          if (!pkgKey) {
            return pkgOffer;
          }
          const basePrice = hasByodOffers && pkgOffer.byodPrice?.[pkgKey] !== undefined ?
            pkgOffer.byodPrice[pkgKey] :
            pkgOffer[pkgKey];

          const benefits = pkgOffer.benefits || [];
          let strikeoutPrice = basePrice;
          if (benefits.length) {
            // Sum all discounts that apply in the first month (periodMo >= 1)
            const totalDiscount = benefits
              .filter(b => b.periodMo >= 1)
              .reduce((sum, b) => sum + Number(b.discount || 0), 0);
            strikeoutPrice = Number((Number(basePrice) + totalDiscount).toFixed(2));
          }

          const { byodPrice: _byod, strikeoutPrice: _s, ...rest } = pkgOffer as any;
          const cleanOffer = {
            ...rest,
            [pkgKey]: basePrice
          };

          if (Number(strikeoutPrice) !== Number(basePrice)) {
            return {
              ...cleanOffer,
              strikeoutPrice
            };
          }
          return cleanOffer;
        })
      };
    }
    // Generated by Copilot- End - 2026-04-21 15:22:02

    return {
      ...componentProps,
      channels: pickChannels(channelsServiceData?.channels, channelListingData?.[":items"]?.chnlListingPageData?.elements?.channels),
      rsnTierLegalText: rsnTierLegalText?.[0]?.stream || {},
      genreLocalChannelMapping,
      signatureExcludedLocalChannels,
      embeddedSvods,
      embeddedIncludedSvods,
      getOffersGenreData,
      offerPrices: resolvedOfferPrices,
      rsnFee: resolvedOfferPrices?.rsnFee,
      geminiFee: resolvedOfferPrices?.geminiFee,
      ...(hasByodOffers ? { byodPackagesList: resolvedOfferPrices?.byodPackagesList } : {}),
      genreNationals,
      packagesConfig,
      genrePackOfferIds,
      creditOffers,
      queryParameters,
      ...(type ? { type } : {})
    };
  } catch (error) {
    logError(ADAPTER_NAME, error, {
      message: "Error in dynamicCustomerAcqCompareAdapter"
    });
    return componentProps;
  }
}

export default dynamicCustomerAcqCompareAdapter;
